import { userService } from '../../../services';

export const config: any = {
  deleteSubAdmin: (params: any) => userService.deleteUser(params),
};
